import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=36e4b066&scoped=true&"
import script from "./Circles.vue?vue&type=script&lang=js&"
export * from "./Circles.vue?vue&type=script&lang=js&"
import style0 from "./Circles.vue?vue&type=style&index=0&id=36e4b066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4b066",
  null
  
)

export default component.exports